export default __webpack_public_path__ + "static/media/cancel.0fdc1629.svg";